import { stringify } from 'utils/query-string';
export const constructUrl = ({ baseURL, params, paramsToAddWithoutKeys })=>{
    let queryString = stringify(params, {
        skipNull: true,
        skipEmptyString: true
    });
    if (paramsToAddWithoutKeys) {
        paramsToAddWithoutKeys.forEach((value)=>{
            if (value) {
                queryString += `&${value}`;
            }
        });
    }
    return `${baseURL}?${queryString}`;
};
export const decodeJWT = (token)=>{
    const [header, payload, signature] = token.split('.');
    if (!header || !payload) {
        throw new Error('Invalid JWT');
    }
    // Decode Base64Url to JSON
    const decodeBase64Url = (str)=>{
        const base64 = str.replace(/-/g, '+').replace(/_/g, '/');
        return decodeURIComponent(atob(base64).split('').map((c)=>`%${c.charCodeAt(0).toString(16).padStart(2, '0')}`).join(''));
    };
    const decodedHeader = JSON.parse(decodeBase64Url(header));
    const decodedPayload = JSON.parse(decodeBase64Url(payload));
    return {
        header: decodedHeader,
        payload: decodedPayload,
        signature
    };
};
